// Cart sidebar (flyout) and add-on copy: the panel, rows, free gift callout, quick adds, and
// in-cart upsells. The rewards headings and toasts are Contentful-backed and live in `useRewards` /
// `useRewardToasts`.
export const cartSidebarContent = {
  // Panel
  myCartHeading: 'My Cart',
  closeCartAriaLabel: 'Close cart',
  // Screen-reader text for the header's cart count
  itemCountLabelOne: '1 item in cart',
  itemCountLabelOtherTemplate: '##Count## items in cart',
  removeItemAriaLabelTemplate: 'Remove ##ItemName## from your cart',

  // Screen-reader announcement when a cart change unlocks rewards
  rewardUnlockedAnnouncementOne: 'Reward unlocked: ##RewardName##',
  rewardUnlockedAnnouncementOther: '##Count## rewards unlocked, including ##RewardName##',

  /**
   * Last-resort description for an unlocked-reward row in the cart flyout, used by both kinds — granted
   * bundles (`AppCartSidebarBundleItem`) and synthesized rewards
   * (`AppCartSidebarSynthesizedRewardCartItem`).
   *
   * Only reached when nothing is authored: a promotion's `rewardCartItemDescription` wins first, and a
   * granted bundle then falls through to its own `cartDescription` before landing here.
   *
   * Shared as one field deliberately: the board writes it "Reward Unlocked!" on the desktop nodes
   * (`15980:29680`, `15980:30208`) and "Reward Unlocked" on the mobile one (`16066:33314`). The trailing
   * exclamation is the intended copy per Gap 4, and a single field is what stops the two row kinds
   * inheriting that inconsistency.
   */
  rewardUnlockedDescription: 'Reward Unlocked!',
  // Price shown on a synthesized reward row
  freeRewardPriceLabel: '$0.00',

  // Free gift callout. The locked heading is Contentful-authored and arrives as a prop; the unlocked
  // copy has no content model yet, so the component takes these as prop defaults.
  freeGiftLockedLabel: 'Locked',
  /**
   * Board `15927:54430`, including the leading gift emoji, which that frame draws.
   *
   * The JIRA timing image writes this with a trailing exclamation mark; the board does not, and the
   * artifact ruling gives the board authority over anything **visual**, copy included — the JIRA image
   * is the tiebreaker for *timing* only. One character, but this is the kind of thing that gets
   * "corrected" back and forth forever without a note saying which artifact won and why.
   *
   * **The emoji is a wrinkle worth knowing.** The *locked* heading's emoji arrives inside the authored
   * Contentful copy and therefore varies per promotion, so a promotion whose locked heading opens with a
   * different glyph will switch to this one as it unlocks. Hardcoding the board's is right until the
   * unlocked heading is authored too — at which point this default stops being reached.
   */
  freeGiftUnlockedHeading: '🎁 Score! You Unlocked a Free Gift',
  /**
   * The line that joins the reward name once unlocked, per the JIRA spec's 2,000ms beat: *"Unlocked copy
   * fades in ('reward name' + 'Added to your order!')"*.
   *
   * **It appears on no board frame.** `15927:54430` is the only unlocked frame in the file — there is no
   * desktop counterpart — and it draws the reward name alone. Kept anyway (decided 2026-08-05) because
   * the task asks for it explicitly and the artifact ruling makes the task co-authoritative with the
   * board on visual matters; without it the unlocked state never says the reward was actually added.
   *
   * Consequence: **its colour and type are unspecified by any artifact.** The treatment borrows the FREE
   * pill's `#3a7f3f` (board `16066:33312` / `15980:29681`, S4) as the nearest reward-positive text
   * colour the board does define, rather than inventing one. Flagged for design to confirm.
   */
  freeGiftAddedToOrder: 'Added to your order!',

  // Quick adds and in-cart upsells
  quickAddsHeading: 'You May Also Like',
  quickAddsAriaLabel: 'You may also like',
  quickAddLabel: 'Quick Add',
  inYourCartLabel: 'In Your Cart',
  addToYourCartLabel: 'Add to Your Cart'
}
